import * as React from 'react'

import { useFeatures } from 'modules/core/hooks/useFeatures'

interface AutomationContextProps {
  canEditAutomations: boolean
}

const automationContext = React.createContext<AutomationContextProps>({
  canEditAutomations: false,
})

const AutomationProvider = automationContext.Provider

export const InsertAutomationProvider = ({ children }: React.PropsWithChildren<object>) => {
  const { has_automations_ui } = useFeatures(['automations_ui'])

  return (
    <AutomationProvider
      value={{
        canEditAutomations: has_automations_ui,
      }}
    >
      {children}
    </AutomationProvider>
  )
}

export const useAutomationContext = () => React.useContext(automationContext)
